import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface ObtenerPreguntasAsambleaRequest {
  asamblea_codigo: string;
  codigo?: string;
}

export interface PreguntaAsambleaRecord {
  pra_codigo: number | string;
  pra_asamblea: number | string;
  pra_asamblea_llave: string;
  pra_fecha_apertura: string;
  pra_fecha_inicio: string;
  pra_fecha_cierre: string;
  pra_texto: string;
  pra_con_tiempo: number;
  pra_con_tiempo_nombre: string;
  pra_minutos: number;
  pra_estatus: string;
  pra_estatus_nombre: string;
}

export interface ModificarPreguntaAsambleaRequest {
  codigo: string;
  asamblea_codigo: string;
  usuario_administrador: string;
  texto: string;
  con_tiempo: string;
  minutos: string;
}

export interface ModificarEstatusPreguntaAsambleaRequest {
  codigo: string;
  asamblea_codigo: string;
  usuario_administrador: string;
  estatus_codigo: string;
}

export interface InsertarPreguntaAsambleaRequest {
  asamblea_codigo: string;
  usuario_administrador: string;
  texto: string;
  con_tiempo: string;
  minutos: string;
}

export const obtenerPreguntasAsamblea = async (payload: ObtenerPreguntasAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<PreguntaAsambleaRecord[]>>(
    "pregunta_asamblea/ObtenerTodos",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const modificarPreguntaAsamblea = async (payload: ModificarPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "pregunta_asamblea/modificar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const modificarEstatusPreguntaAsamblea = async (payload: ModificarEstatusPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "pregunta_asamblea/Modificar_Estatus",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const insertarPreguntaAsamblea = async (payload: InsertarPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "pregunta_asamblea/Insertar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};
